module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "calibre_pb_0"
    }
  }, [_c('hr', {
    staticClass: "chap2"
  }), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "CONTENTS"
    }
  }, [_vm._v("CONTENTS")])]), _vm._v(" "), _c('table', {
    staticClass: "autotable",
    attrs: {
      "summary": "",
      "width": "95%"
    }
  }, [_c('tbody', {
    staticClass: "calibre2"
  }, [_c('tr', {
    staticClass: "calibre3"
  }, [_c('td', {
    staticClass: "tdr"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdr1"
  }, [_vm._v("PAGE")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre3"
  }, [_c('td', {
    staticClass: "tdr"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_vm._v("IN APPRECIATION OF WILLIAM F. CODY")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0003#Page_1"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre3"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("I.")]), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_vm._v("JUNIPER JOE’S JUBILEE.")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0004#CHAPTER_I"
    }
  }, [_vm._v("5")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre3"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("II.")]), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_vm._v("“JACKSON DANE, DETECTIVE.”")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0005#Page_15"
    }
  }, [_vm._v("15")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre3"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("III.")]), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_vm._v("THE BARON FINDS EXCITEMENT.")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0006#Page_29"
    }
  }, [_vm._v("29")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre3"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("IV.")]), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_vm._v("SUSPICIONS.")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0007#Page_40"
    }
  }, [_vm._v("40")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre3"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("V.")]), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_vm._v("THE SURPRISE AT JUNIPER JOE’S.")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0008#Page_49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre3"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("VI.")]), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_vm._v("THE BARON’S ADVENTURES.")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0009#Page_57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre3"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("VII.")]), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_vm._v("A STARTLING DISCOVERY.")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0010#Page_71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre3"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("VIII.")]), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_vm._v("STRANGE DISAPPEARANCES.")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0011#Page_83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("83")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre3"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("IX.")]), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_vm._v("THE CHASE.")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0012#Page_88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("88")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre3"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("X.")]), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_vm._v("STARTLING REVELATIONS.")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0013#Page_99",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("99")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre3"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XI.")]), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_vm._v("THE FOOL OF FOLLY MOUNTAIN.")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0014#Page_106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("106")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre3"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XII.")]), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_vm._v("THE MISSION OF WHITE-EYED MOSES.")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0015#Page_117",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("117")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre3"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XIII.")]), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_vm._v("BENSON ACTS.")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0016#Page_127",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("127")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre3"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XIV.")]), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_vm._v("A WORRIED SHERIFF.")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0017#Page_133",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("133")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre3"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XV.")]), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_vm._v("THE SHERIFF’S WARNING.")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0018#Page_145",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("145")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre3"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XVI.")]), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_vm._v("THE GOPHER BITES.")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0019#Page_151",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("151")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre3"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XVII.")]), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_vm._v("THE BARON’S EXPERIENCE.")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0020#Page_158",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("158")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre3"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XVIII.")]), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_vm._v("AN ASSASSIN AT WORK.")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0021#Page_167",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("167")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre3"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XIX.")]), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_vm._v("SHIFTING THE PRISONERS.")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0022#Page_182",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("182")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre3"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XX.")]), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_vm._v("SPRINGING THE TRAP.")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0023#Page_196",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("196")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre3"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XXI.")]), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_vm._v("TIM BENSON’S ESCAPE.")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0024#Page_206",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("206")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre3"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XXII.")]), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_vm._v("TIM BENSON’S CLEVERNESS.")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0025#Page_211",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("211")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre3"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XXIII.")]), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_vm._v("BUFFALO BILL’S HOLD-UP.")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0026#Page_221",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("221")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre3"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XXIV.")]), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_vm._v("GORILLA JAKE.")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0027#Page_237",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("237")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre3"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XXV.")]), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_vm._v("THE BETTS BROTHERS.")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0028#Page_253",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("253")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre3"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XXVI.")]), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_vm._v("IN THE UTE VILLAGES.")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0029#Page_259",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("259")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre3"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XXVII.")]), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_vm._v("MATT SHEPARD AND THE MASSACRE.")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0030#Page_263",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("263")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre3"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XXVIII.")]), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_vm._v("HOW IT WORKED.")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0031#Page_275",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("275")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre3"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XXIX.")]), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_vm._v("THE DARING OF BILL BETTS.")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0032#Page_294",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("294")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre3"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XXX.")]), _vm._v(" "), _c('td', {
    staticClass: "tdl"
  }, [_vm._v("THE CAPTURE OF BENSON.")]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0033#Page_305",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("305")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a637da12","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0002.vue
// module id = 60
// module chunks = 0